import ReactDOM from "react-dom";

import { ProvideStore } from "src/providers/store";
import { ProvideAuth } from "src/providers/route";

import App from "./App";
import "./firbaseConfig";

ReactDOM.render(
  <ProvideStore>
    <ProvideAuth>
      <App />
    </ProvideAuth>
  </ProvideStore>,
  document.getElementById("root")
);
